import { render, staticRenderFns } from "./SourceListPopover.vue?vue&type=template&id=df47eaae&scoped=true&"
import script from "./SourceListPopover.vue?vue&type=script&lang=js&"
export * from "./SourceListPopover.vue?vue&type=script&lang=js&"
import style0 from "./SourceListPopover.vue?vue&type=style&index=0&id=df47eaae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df47eaae",
  null
  
)

export default component.exports